import BaseService from '@/services/base_service';
import Axios from 'axios';

export default class DiscountService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/cupom-desconto', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/cupom-desconto/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {

    try {
      return await axios.post('cupom-desconto/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/cupom-desconto/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/cupom-desconto/' + id);
    } catch (e) {
      throw e;
    }
  }

  async import(model) {
    try {
      return await axios.post('/cupom-desconto/upload', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/discount.js